'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router';
import Avatar from 'components/base/Avatar';
import Spinner from 'components/base/Spinner';
import CheckBox from 'components/base/form-components/CheckBox';
import CheckBoxNoFormsy from 'components/base/form-components/CheckBoxNoFormsy';
import utils from 'services/utils';
import _ from 'underscore';

import 'styles/ListItem.scss';

const propTypes = {
    showCheckbox: PropTypes.bool,
    downloading: PropTypes.bool,
    colorName: PropTypes.string,
    iconName: PropTypes.string,
    avatar: PropTypes.object,
    actions: PropTypes.object,
    inverseColours: PropTypes.bool,
    link: PropTypes.string,
    error: PropTypes.bool,
    className: PropTypes.string,
    allowSingleLine: PropTypes.bool,
    alignTop: PropTypes.bool,
    rightAlignContent: PropTypes.bool,
    hideContent: PropTypes.bool,
    id: PropTypes.string,
};

const defaultProps = {
    enableSelection: false,
    colorName: "$colorGrayDark",
};

class ListItem extends React.Component {

    render() {

        if (this.props.hide) {
            return <span />;
        }

        var checkboxContainer = this.props.isMultiSelectMode ? ( 
            this.props.noFormsy ?
                (      
                    <CheckBoxNoFormsy 
                        key={this.props.id}
                        name={String(this.props.id)} 
                        onChange={this.props.onCheckboxChange} 
                        onClick={this.props.onClick} 
                        checked={this.props.isChecked}
                        disabled={this.props.disableCheckbox}
                    />
                ) :
                (
                    <CheckBox 
                        key={this.props.id}
                        name={String(this.props.id)} 
                        onChange={this.props.onCheckboxChange} 
                        onClick={this.props.onClick} 
                        checked={this.props.isChecked}
                        initialValue={this.props.isChecked}
                        disabled={this.props.disableCheckbox}
                    /> 
                )
        ) : null;
        
        var iconAvatarContainer = this.props.iconName ? (
            <div 
                className={"list-icon-container " + this.props.iconName} 
                style={{color:this.props.colorName}}
            />
        ) : null;

        iconAvatarContainer = this.props.avatar ? (
            <div className={"list-avatar-container"}>
                {this.props.avatar}
            </div>
        ) : iconAvatarContainer;
        
        
        var rightContentContainer = this.props.rightAlignContent ? (
            <div className="right-content-container">
                {this.props.content}
            </div>
        ) : null;
    
       
        var headingContainer = this.props.heading ? (
            <div 
                className="heading-container" 
                style={rightContentContainer ? {display:"block"} : null}
            >
                <span className="heading-container-text">
                    {this.props.heading}
                </span>
                {this.props.subheading ? (
                    <span className="sub-heading">
                        {this.props.subheading}
                    </span>
                ) : null}
            </div>
        ) : null;
        
        var contentContainer = this.props.rightAlignContent ? null : this.props.content; 

        if (typeof contentContainer === "string") {
            contentContainer = <div className="message">{contentContainer}</div>;
        }

        var actionsContainer = this.props.actions && !this.props.isMultiSelectMode ? <div className="actions-container">{this.props.actions}</div> : null;
        actionsContainer = this.props.downloading ? (
            <div className="actions-container spinner-container-area">
                <Spinner
                    display={this.props.downloading}
                    id={this.props.id}
                    color={this.inverseColours ? "#fff" : null}
                />
            </div>
        ) : actionsContainer;

        if (this.props.link && !this.props.isMultiSelectMode && !this.props.disabled) {
            headingContainer = this.props.heading ? (
                <Link className="link heading-container" to={this.props.link}>
                    <span>{this.props.heading}</span>{this.props.subheading ? <span className="sub-heading">{this.props.subheading}</span> : ""}
                </Link>
            ) : null;

            iconAvatarContainer = iconAvatarContainer ? <Link className="link" to={this.props.link}>{iconAvatarContainer}</Link> : null;
            //style={rightContentContainer || actionsContainer?{display:"block"}:{display:"inline-block"}}
        } else if (this.props.onClick && !this.props.isMultiSelectMode && !this.props.disabled) {
            headingContainer = this.props.heading ? (
                <a className="link heading-container" href="javascript:;" onClick={this.props.onClick}>
                    <span>{this.props.heading}</span>{this.props.subheading ? <span className="sub-heading">{this.props.subheading}</span> : ""}
                </a>
            ) : null;
            iconAvatarContainer = iconAvatarContainer ? <a className="link" href="javascript:;" onClick={this.props.onClick}>{iconAvatarContainer}</a> : null;
            //style={rightContentContainer || actionsContainer?{display:"block"}:{display:"inline-block"}}
        } 


        var detailsClasses = classNames(
            'li-details', 
            this.props.className,
            { 
                'no-icon-avatar': !iconAvatarContainer,
                'no-heading': !headingContainer,
                'align-top': this.props.alignTop,
                'no-details': !contentContainer,
                'hide-content': this.props.hideContent,
            }
        );

        var headingClasses = classNames(
            'li-heading', 
            this.props.className,
            { 
                'no-details': !contentContainer,
                'no-heading': !headingContainer,
                'align-top': this.props.alignTop,
            }
        );

        var altClasses = classNames(
            'li-alt', 
            this.props.className,
            { 
                'has-content': rightContentContainer,
                'has-actions': actionsContainer,
                'align-top': this.props.alignTop,
            }
        );


        var classes = classNames(
            'list-item-row', 
            this.props.className,
            { 
                'single-line-huge': this.props.allowSingleLineOnHuge,
                'single-line-medium' : this.props.allowSingleLineOnMedium,
                'disabled' : this.props.disabled,
                'multiselect-mode': this.props.isMultiSelectMode,
                'caution': this.props.caution,
                'multiline': this.props.multiline,
                'no-heading': !headingContainer,
                'align-top': this.props.alignTop,
            }
        );

        const id = this.props.id ? "list-item-{0}".format(this.props.id) : null;
        return (
            <div id={id} className={classes}>
                <div className={headingClasses}>
                    <div className={this.props.isMultiSelectMode ? "checkbox-column" : "checkbox-column hide"}>
                        {checkboxContainer}
                    </div>
                    <div className="symbol-column">
                        {iconAvatarContainer}
                    </div>
                    {headingContainer}
                </div>
                <div className={detailsClasses}>
                    {contentContainer}
                </div>
                <div className={altClasses}>
                    {rightContentContainer}
                    {actionsContainer}
                </div>
            </div>
        );
    }
}

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;

export default ListItem; 